import React from "react";
import { VendorShipmentDetails } from "src/types/database/vendor";
import { TextInputBox } from "src/components/ui/inputs";

interface Props {
  shipmentDetails: VendorShipmentDetails;
  onFieldChange: (field: keyof VendorShipmentDetails, value: any) => void;
  getFieldErrorMessage: (fieldName: string) => string | undefined;
}

const ContactInfoSection: React.FC<Props> = ({ shipmentDetails, onFieldChange, getFieldErrorMessage }) => {
  return (
    <div className="p-6 space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <TextInputBox
            id="contact-person"
            label="Contact Person Name"
            value={shipmentDetails.contactPerson || ""}
            onChange={(value: string) => onFieldChange("contactPerson", value)}
            error={getFieldErrorMessage("contactPerson")}
          />
        </div>

        <div>
          <TextInputBox
            id="shipment-email"
            label="Email"
            type="email"
            value={shipmentDetails.email || ""}
            onChange={(value: string) => onFieldChange("email", value)}
            error={getFieldErrorMessage("email")}
          />
        </div>
      </div>

      <div>
        <TextInputBox
          id="contact-info"
          label="Contact Number"
          value={shipmentDetails.contactInfo || ""}
          onChange={(value: string) => onFieldChange("contactInfo", value)}
          error={getFieldErrorMessage("contactInfo")}
        />
      </div>
    </div>
  );
};

export default ContactInfoSection;
